export const DUPLICATE_PHONE_SIGN_IN_MESSAGE = 'We were unable to identify an account by phone, please scan to sign in';

export const DUPLICATE_PHONE_QUERY_PARAM = 'duplicate-phone';
